<template>
	<div>
		<sBox title="Filtar tarefas">
			<div slot="body">
				<div class="row">
					<div class="col-sm-3">
						Código
						<input
							v-model="filter.cod"
							@keyup="fxFilter"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-sm-6">
						Tarefa
						<input
							v-model="filter.tarefa"
							@keyup="fxFilter"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-sm-3">
						Tipo de Tarefa
						<select
							v-model="filter.tip_tar"
							@change="fxFilter"
							class="form-control"
						>
							<option value="">Escolher</option>
							<option value="c">Contratual</option>
							<option value="a">Avulsa</option>
						</select>
					</div>
				</div>
			</div>
		</sBox>
		<sBox title="Grade de Tarefas">
			<div slot="tools">
				<aBtn
					action="private-save-tasks"
					@click="$refs.modal.open()"
					text="Categoria"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<sTable
					ref="tab"
					actionRead="private-read-tasks"
					actionDelete="private-delete-tasks"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					:tags="tags"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<!-- @input='filter($event.target.value)' -->
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, modal, aBtn },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'tarefa', label: 'Tarefa' },
					{ data: 'iniciar', label: 'Inicio' },
					{ data: 'duracao', label: 'Duração' },
					{ data: 'recorrencia', label: 'Recorrêcia' },
					{ data: 'tiptarefa', label: 'Tipo' },
				],
				tags: [
					{
						cod: 'tiptarefa',
						value: 'c',
						html: 'Contratual',
						color: 'success',
					},
					{
						cod: 'tiptarefa',
						value: 'a',
						html: 'Avulsa',
						color: 'info',
					},
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{ cod: 'iniciar', fx: this.cTime },
					{ cod: 'duracao', fx: this.cTime },
					{ cod: 'recorrencia', fx: this.cTime },
				],
				filter: {
					cod: '',
					tarefa: '',
					tip_tar: '',
				},
			};
		},
		methods: {
			cTime(time) {
				let D = Math.round(time / 1440);
				let H = Math.round((time - D * 1440) / 60);
				let M = time - (D * 1440 + H * 60);
				let resp = '';
				if (D > 0) {
					if (D == 1) resp += `${D} Dia `;
					else resp += `${D} Dias `;
				}
				if (H > 0) {
					if (H == 1) resp += `${H} Hora `;
					else resp += `${H} Horas `;
				}
				if (M > 0) {
					if (M == 1) resp += `${M} Minuto`;
					else resp += `${M} Minutos`;
				}
				if (resp == '') return '0 Minutos';
				return resp;
			},
			fxFilter() {
				let Filter = [];
				if (this.filter.cod != '')
					Filter.push(`cod = '${this.filter.cod}'`);
				if (this.filter.tarefa != '')
					Filter.push(`tarefa like '%${this.filter.tarefa}%'`);
				if (this.filter.tip_tar != '')
					Filter.push(`tiptarefa = '${this.filter.tip_tar}'`);
				console.log(Filter.join(' and '));
				if (Filter != '')
					this.$refs.tab.setFilter(Filter.join(' and '));
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Modelos de Tarefas', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/tasks/index.vue